
import React from 'react';
import { Search, Eye, Download } from 'lucide-react';
import type { HistoryEntry } from '../types';

interface HistoryViewProps {
  history: HistoryEntry[];
}

const HistoryView: React.FC<HistoryViewProps> = ({ history }) => {
  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-white mb-2">Declaration History</h2>
          <p className="text-gray-400">View and manage your past declarations</p>
        </div>
        <div className="flex gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="Search declarations..."
              className="pl-10 pr-4 py-2 border border-gray-600 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 bg-gray-800 text-white placeholder-gray-500"
            />
            <Search className="absolute left-3 top-2.5 text-gray-500" size={20} />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="glass-card rounded-xl p-6">
          <p className="text-sm text-gray-400 mb-1">Total Declarations</p>
          <p className="text-3xl font-bold text-white">{history.length}</p>
        </div>
        <div className="glass-card rounded-xl p-6">
          <p className="text-sm text-gray-400 mb-1">This Month</p>
          <p className="text-3xl font-bold text-teal-400">12</p>
        </div>
        <div className="glass-card rounded-xl p-6">
          <p className="text-sm text-gray-400 mb-1">Success Rate</p>
          <p className="text-3xl font-bold text-emerald-400">98%</p>
        </div>
      </div>

      <div className="glass-card rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-800 border-b border-gray-700">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">Date</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">Reference</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">Importer</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">Status</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {history.map((item) => (
                <tr key={item.id} className="hover:bg-gray-800 transition-colors">
                  <td className="px-6 py-4 text-sm text-gray-400">{item.date}</td>
                  <td className="px-6 py-4">
                    <span className="text-sm font-mono font-semibold text-white">{item.reference}</span>
                  </td>
                  <td className="px-6 py-4 text-sm text-white">{item.importer}</td>
                  <td className="px-6 py-4">
                    <span className="px-3 py-1 bg-emerald-900/50 text-emerald-400 text-xs font-semibold rounded-full">
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex gap-2">
                      <button className="p-2 hover:bg-blue-900/50 text-blue-400 rounded-lg transition-colors"><Eye size={18} /></button>
                      <button className="p-2 hover:bg-teal-900/50 text-teal-400 rounded-lg transition-colors"><Download size={18} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HistoryView;
